import { ENV } from './types'

import developmentSettings from '../../../../settings.dev.json'
import productionSettings from '../../../../settings.prod.json'

export const isProduction = () => process.env.NODE_ENV === ENV.PRODUCTION
export const ENVIRONMENT = isProduction() ? ENV.PRODUCTION : ENV.STAGING
export const SYSTEM = 'app-live-user'

class SettingsHelper {
  static setting = isProduction()
    ? productionSettings
    : developmentSettings
}

export const getLiveURL = (code: string) => `${location.origin}/${code}`

export default SettingsHelper.setting
